export const AGREEMENT_UPDATE = 'AGREEMENT_UPDATE';

export const GET_LEGAL_AGREEMENT = 'legalAgreement/GET_LEGAL_AGREEMENT';
export const GET_LEGAL_AGREEMENT_SUCCESS = 'legalAgreement/GET_LEGAL_AGREEMENT_SUCCESS';
export const GET_LEGAL_AGREEMENT_FAILURE = 'legalAgreement/GET_LEGAL_AGREEMENT_FAILURE';
export const LEGAL_AGREEMENT_URL = 'content-service/content/legal-agreement';
